import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { compose, map } from 'crocks';
import merge from 'deepmerge';
import getPdfChars from './pdfChars'; // toRows :: [a] -> [b]

var toRows = function toRows(chars) {
  var rows = chars.reduce(function (acc, char) {
    acc[char.y] = acc[char.y] === undefined ? [char] : [].concat(_toConsumableArray(acc[char.y]), [char]);
    return acc;
  }, {});
  return Object.entries(rows);
};

var rowToColumns = function rowToColumns(columns) {
  return function (rowArray) {
    var rowData = rowArray[1];
    var columnizedData = rowData.reduce(function (rowObj, char) {
      var _columns$find = columns.find(function (columnX) {
        return char.x < columnX.x;
      }),
          accessor = _columns$find.accessor;

      return merge(rowObj, _defineProperty({}, accessor, [char]));
    }, {});
    return columnizedData;
  };
};

var mergeRows = function mergeRows(mergeRule) {
  return function (rows) {
    switch (mergeRule.direction) {
      case 'up':
        return rows.reduce(function (table, row) {
          if (row[mergeRule.requiredKey]) return [].concat(_toConsumableArray(table), [row]);
          var last = table.slice(-1)[0];
          var rest = table.slice(0, -1);
          var newLast = merge(last, row);
          return [].concat(_toConsumableArray(rest), [newLast]);
        }, []);

      default:
        throw new Error("mergeRows: unknown merge direction: ".concat(mergeRule.direction));
    }
  };
};

var formatCell = function formatCell(chars) {
  return chars.reduce(function (string, char) {
    return string.concat(char.text);
  }, '');
};

var parseTable = function parseTable(rules) {
  return function (pagesOfRows) {
    // for each page
    var pages = pagesOfRows.map(map(rowToColumns(rules.columns))); // merge pages

    var justRows = pages.reduce(function (rows, page) {
      return rows.concat(page);
    }, []); // apply merge rows rules

    var mergedRows = mergeRows(rules.mergeRules)(justRows); // merge cell data to string
    // for each row

    var formattedCells = mergedRows.map(function (row) {
      // for each column (key) in row
      var cellArray = Object.entries(row).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return [key, formatCell(value)];
      });
      var cellObjects = Object.fromEntries(cellArray);
      return cellObjects;
    }); // return tables

    return {
      data: formattedCells,
      columns: rules.columns
    };
  };
};

var valueParse = function valueParse(pagesOfChars) {
  var pages = pagesOfChars.map(function (page) {
    var rows = page.map(function (row) {
      var chars = row[1];
      return formatCell(chars);
    });
    return rows.join('/n');
  });
  return pages;
};

var isBetween = function isBetween(start, stop) {
  return function (value) {
    var _ref3 = start < stop ? [start, stop] : [stop, start],
        _ref4 = _slicedToArray(_ref3, 2),
        min = _ref4[0],
        max = _ref4[1];

    return value >= min && value <= max;
  };
};

var getInbounds = function getInbounds(rules) {
  return function (pagesOfChars) {
    return pagesOfChars.map(function (page, index) {
      var pageRules = rules[index] || rules.all;
      if (!pageRules) return [];
      var _pageRules$bounds = pageRules.bounds,
          top = _pageRules$bounds.top,
          bottom = _pageRules$bounds.bottom,
          left = _pageRules$bounds.left,
          right = _pageRules$bounds.right;
      return page.filter(function (_ref5) {
        var x = _ref5.x,
            y = _ref5.y;
        return isBetween(top, bottom)(y) && isBetween(left, right)(x);
      });
    });
  };
};

var selectParser = function selectParser(type, rules) {
  switch (type) {
    case 'table':
      return parseTable(rules);

    case 'value':
      return valueParse;

    default:
      throw new Error("selectParser: invalid parse type ".concat(type));
  }
};

export default function pdfTextExtractor(_x, _x2) {
  return _pdfTextExtractor.apply(this, arguments);
}

function _pdfTextExtractor() {
  _pdfTextExtractor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(src, template) {
    var captureList, options, pdf, pagesOfChars, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            captureList = template.captureList, options = template.options;
            _context.next = 3;
            return getPdfChars(src, options && options.charCodeOffset);

          case 3:
            pdf = _context.sent;
            pagesOfChars = pdf.pages;
            data = captureList.map(function (_ref6) {
              var name = _ref6.name,
                  type = _ref6.type,
                  rules = _ref6.rules;
              var parse = compose(selectParser(type, rules), map(toRows), getInbounds(rules));
              return [name, parse(pagesOfChars)];
            });
            return _context.abrupt("return", Object.fromEntries(data));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _pdfTextExtractor.apply(this, arguments);
}